import React, { useEffect } from 'react';

import shopify from "frontend/js/shopify";

let variantInventories = null;

export const ProductCombinedStoreValidator = ({ formName, product }) => {

  function checkCombinedStoreStocks(nodes) {
    if (!nodes?.length) return;

    // Check if Combined Store location exists in any of the inventory levels
    const hasCombinedStore = nodes.some(node => {
      const inventoryLevels = node.inventoryItem?.inventoryLevels?.nodes || [];
      return inventoryLevels.some(level => level.location.name === "Combined Store");
    });

    // If no Combined Store location found, skip this validation (INTL case)
    if (!hasCombinedStore) return;

    nodes.forEach((node, index) => {
      const inventoryLevels = node.inventoryItem?.inventoryLevels?.nodes || []

      if (inventoryLevels?.length) {
        const combinedStore = inventoryLevels.find(inventorylevel => inventorylevel.location.name === "Combined Store");

        if (!combinedStore || combinedStore.quantities[0]?.quantity <= 0) {
          const { option2 } = product.variants[index];
          const sizeButtons = document.querySelectorAll(`[name="Size-${formName}"][value="${option2}"]`);

          if (sizeButtons.length) {
            sizeButtons.forEach(button => {
              // @ts-ignore
              button.disabled = true;
              button.className = 'disabled hidden [&:checked+label]:bg-[#00263E] [&:checked+label]:text-white';
              const labelEl = document.querySelector(`.pdp-main label[for="${button.id}"]`);

              labelEl?.classList?.add('pointer-events-none');
            });
          }
        }
      }
    });
  }

  useEffect(() => {
    if (formName === 'pdp-main' || formName === 'size-selector') {
      async function fetchInvetoryDetails() {

        const variantIds = product?.variants?.map(variant => variant.id) || [];
        const response = await shopify.getInventoryDetails(variantIds);
        const nodes = response?.data?.nodes || []

        variantInventories = nodes;
        
        // Check if Combined Store location exists before processing unavailable variants
        const hasCombinedStore = nodes.some(node => {
          const inventoryLevels = node.inventoryItem?.inventoryLevels?.nodes || [];
          return inventoryLevels.some(level => level.location.name === "Combined Store");
        });

        // Only process unavailable variants if Combined Store exists (AU case)
        if (hasCombinedStore) {
          const unavailableForShipping = nodes?.filter(node => {
            const inventoryLevels = node.inventoryItem?.inventoryLevels?.nodes || []
            const combinedStore = inventoryLevels.find(inventorylevel => inventorylevel.location.name === "Combined Store");
            return !combinedStore || combinedStore.quantities[0]?.quantity <= 0;
          }).map(node => node.id.split("/").pop()) || [];

          const variantChangeEvent = new CustomEvent('unavailableForShipping', {
            detail: { unavailableForShipping },
          });

          window.dispatchEvent(variantChangeEvent);
        }

        checkCombinedStoreStocks(nodes);
      }

      fetchInvetoryDetails();
    }

    function handleVariantChange() {
      checkCombinedStoreStocks(variantInventories);
    }

    window.addEventListener('variant:change', handleVariantChange);

    return () => {
      window.removeEventListener('variant:change', handleVariantChange);
    }
  }, [])

  return (<div></div>)
};

export default ProductCombinedStoreValidator;